/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ban': {
    width: 16,
    height: 16,
    viewBox: '-192 -192 896 896',
    data: '<path pid="0" _fill="currentColor" d="M256 8C119.033 8 8 119.033 8 256s111.033 248 248 248 248-111.033 248-248S392.967 8 256 8zM103.265 408.735c-80.622-80.622-84.149-208.957-10.9-293.743l304.644 304.643c-84.804 73.264-213.138 69.706-293.744-10.9zm316.37-11.727L114.992 92.365c84.804-73.263 213.137-69.705 293.743 10.9 80.622 80.621 84.149 208.957 10.9 293.743z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/ban.js